import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { authConstants } from 'src/app/components/auth/auth.constants';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { environment } from 'src/environments/environment';
import { AccountDataActions } from '../../account-data.actionsenum.';

@Component({
  selector: 'app-auth-account-data-form',
  templateUrl: './auth-account-data-form.component.html',
  styleUrls: ['./auth-account-data-form.component.sass'],
})
export class AuthAccountDataFormComponent implements OnInit {
  @Input() country: number;
  @Input() loader: boolean;
  @Input() passwordCheckerField: string;
  @Input() passwordCheckerName: string;
  @Input() passwordCheckerParams: { [key: string]: string };
  @Input() formData: UntypedFormGroup;
  @Input() nextStepAction: AccountDataActions;
  @Input() actionList: Actions<AccountDataActions, any>;
  @Input() termsLink: string;
  @Input() politicsLink: string;
  authConstants = authConstants;

  constructor() {
    /* */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /* */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * emit event save step
   */
  saveStep(): void {
    if (this.formData.get('isInvalidForm').value) {
      return environment.guardClause;
    }
    this.actionList.emit(this.nextStepAction, null);
  }
}
